<template>
    <!-- テストラン名 -->
    <fieldset id="testrunName">
        <legend>実行するテストラン名</legend>
        <div>
            実行対象のテストラン名を入力してください。<br>
            プロジェクトエクスポートしたsyncフォルダに含まれているテストランが実行可能です。<br>
            確認したい場合、show_testrunコマンドを使用してください。<br>
            テストランは上から順番に実行されます。
        </div>
        <div class="form-area">
            <v-btn class="add-form click-cursor" @click="addForm">テストラン名フォームを追加</v-btn>
            <!-- フォーム -->
            <div v-for="(form, index) in inputedTestrunNames" :key="index" class="name-form">
                <label for="notSilentRadio">{{ index + 1 }}. テストラン名: </label>
                <input type="text" class="input-text-row" v-model="form.name" @input="updateOpt"
                    placeholder="実行したいテストラン名">
                <!-- フォームを削除するボタン -->
                <v-btn class="delete-form click-cursor" @click="removeForm(index)">削除</v-btn>
            </div>
        </div>
    </fieldset>
</template>

<script>
import { computed, onMounted, reactive } from 'vue';

import cacheUtils from '@/js/cacheUtils';

export default {
    name: 'TestrunNameForm',
    setup(_, { emit }) {
        // ###############
        // フォームデータ #
        // ###############
        const inputedTestrunNames = reactive([{ name: '' }]);

        // ###################################
        // QT連携テストラン名セレクトリスト制御 #
        // ###################################
        const testrunNameList = computed(() => {
            const retList = []
            for (let i = 0; i < inputedTestrunNames.length; i++) {
                if (inputedTestrunNames[i].name) {
                    retList.push(inputedTestrunNames[i].name)
                }
            }
            return retList
        })

        // ########################
        // テストラン名フォーム制御 #
        // ########################
        // フォームを追加する関数
        const addForm = () => {
            inputedTestrunNames.push({ name: '' })
        };

        // フォームを削除する関数
        const removeForm = (index) => {
            if (inputedTestrunNames.length === 1) {
                return;
            }
            inputedTestrunNames.splice(index, 1)
            updateOpt()
        };


        // #############
        // コマンド生成 #
        // #############
        const updateOpt = async () => {
            // サイレント
            let createdOpt = ""

            // テストラン名
            for (let i = 0; i < inputedTestrunNames.length; i++) {
                const inputedTestrunName = inputedTestrunNames[i]
                if (inputedTestrunName.name === "") {
                    continue
                }
                if (createdOpt) {
                    createdOpt += "/"
                }
                createdOpt += inputedTestrunName.name
            }

            // cacheに保存
            await cacheUtils.saveData("testrunNames", inputedTestrunNames)

            // コマンド生成&表示は親コンポーネント
            emit("update-opt", "testrunName", createdOpt)
            emit("update-qt-testrun", testrunNameList.value)
        }

        // ###############
        // ライフサイクル #
        // ###############
        onMounted(async () => {
            // cacheから取り出し 
            const cacheTestrunNames = await cacheUtils.getData("testrunNames", [{ name: '' }])
            // reactive変数の再代入
            Object.assign(inputedTestrunNames, cacheTestrunNames);

            await updateOpt()
        })

        return {
            // フォームデータ
            inputedTestrunNames,
            // コマンド生成
            updateOpt,
            // フォーム制御
            addForm,
            removeForm,

        }
    }
}
</script>

<style scoped>
.add-form {
    background-color: rgb(0, 156, 225);
    color: white;
    padding: 6px;
    margin-bottom: 8px;
    border: unset;
}

.add-form:hover {
    background-color: rgb(2, 135, 192);
}

.delete-form {
    background-color: #ff4900;
    color: white;
    padding: 3px 6px;
    margin-left: 8px;
    border: unset;
    height: max-content !important;
    bottom: 2px;
}

.delete-form:hover {
    background-color: #ba3501;
}

.name-form {
    margin-bottom: 8px;
}

.name-form:last-child {
    margin-bottom: unset;
}

.input-text-row {
    width: 70%;
}
</style>